export default __webpack_public_path__ + "static/media/scene_10.5ba83ecc.mp3";